module.exports = __webpack_public_path__ + "static/media/social.51d2fccf.webp";